"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToPascalConverter = void 0;
const snakeToCamel_1 = require("./snakeToCamel");
const snakeToPascalConverter = (string) => (0, snakeToCamel_1.snakeToCamelConverter)(string.replace(/^\w/, (s) => s.toUpperCase()));
exports.snakeToPascalConverter = snakeToPascalConverter;
//# sourceMappingURL=snakeToPascal.js.map